//====================================================
//  Function: Benefits
//====================================================
function componentSaleBanner() {
  var saleBanner = `
		<a href="/vypredaj/" class="sale-block">
			<div class="sale-block__title">
				<svg class="icon-svg icon-sale">
						<use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-sale"></use>
				</svg>
				<span class="sale-block__text">${sale}</span>
			</div>
		</a>
	`;

  // Category
  if ($(".type-category").length) {
    $(saleBanner).insertBefore($(".price-group"));
  }

  if ($(".type-index").length) {
    $(saleBanner).insertAfter($(".sidebar .sidebar-inner"));
  }
}
